import { SkeletonButton, SkeletonPageHeader, SkeletonPanel, SkeletonRect, SkeletonTable, SkeletonText } from '../Skeleton';

// =============================================================================
// H9 > 공지사항 관리 skeleton.
// Mirrors: PageHeader + space/status filters + search + table + pagination.
// =============================================================================

export function H9NoticesSkeleton(): JSX.Element {
  return (
    <div className="h-full overflow-auto p-6">
      <SkeletonPageHeader className="mb-6" />

      <div className="mb-4 flex flex-wrap items-end gap-3">
        <div className="flex flex-col gap-1">
          <SkeletonText width={50} height="0.85em" />
          <SkeletonRect width={160} height={38} />
        </div>
        <div className="flex flex-col gap-1">
          <SkeletonText width={40} height="0.85em" />
          <SkeletonRect width={130} height={38} />
        </div>
        <SkeletonRect width={240} height={38} className="ml-auto" />
      </div>

      <SkeletonPanel header={false} className="overflow-hidden">
        <SkeletonTable
          rowCount={6}
          columns={[
            { label: 'No.', width: '8%' },
            { label: '스페이스', width: '18%' },
            { label: '공지 제목', width: '26%' },
            { label: '활성 여부', width: '12%' },
            { label: '생성 시각', width: '16%' },
            { label: '상태', width: '10%' },
            { width: '10%' },
          ]}
        />
      </SkeletonPanel>

      <div className="mt-3 flex justify-end gap-1">
        {Array.from({ length: 7 }).map((_, i) => (
          <SkeletonRect key={i} width={32} height={30} />
        ))}
      </div>
    </div>
  );
}
